export const multimodalRouteStages = [
    {
        id: "pickup",
        number: "01",
        icon: "truck",
        statusTone: "completed",
        titleKey: "main.landing.multimodal.stages.pickup.title",
        routeKey: "main.landing.multimodal.stages.pickup.route",
        participantKey: "main.landing.multimodal.stages.pickup.participant",
        statusKey: "main.landing.multimodal.stages.pickup.status",
        checkpointKey: "main.landing.multimodal.stages.pickup.checkpoint",
        documentsKey: "main.landing.multimodal.stages.pickup.documents",
        scheduleKey: "main.landing.multimodal.stages.pickup.schedule",
    },
    {
        id: "sea",
        number: "02",
        icon: "ship",
        statusTone: "completed",
        titleKey: "main.landing.multimodal.stages.sea.title",
        routeKey: "main.landing.multimodal.stages.sea.route",
        participantKey: "main.landing.multimodal.stages.sea.participant",
        statusKey: "main.landing.multimodal.stages.sea.status",
        checkpointKey: "main.landing.multimodal.stages.sea.checkpoint",
        documentsKey: "main.landing.multimodal.stages.sea.documents",
        scheduleKey: "main.landing.multimodal.stages.sea.schedule",
    },
    {
        id: "rail",
        number: "03",
        icon: "train",
        statusTone: "active",
        titleKey: "main.landing.multimodal.stages.rail.title",
        routeKey: "main.landing.multimodal.stages.rail.route",
        participantKey: "main.landing.multimodal.stages.rail.participant",
        statusKey: "main.landing.multimodal.stages.rail.status",
        checkpointKey: "main.landing.multimodal.stages.rail.checkpoint",
        documentsKey: "main.landing.multimodal.stages.rail.documents",
        scheduleKey: "main.landing.multimodal.stages.rail.schedule",
    },
    {
        id: "last-mile",
        number: "04",
        icon: "truck",
        statusTone: "planned",
        titleKey: "main.landing.multimodal.stages.lastMile.title",
        routeKey: "main.landing.multimodal.stages.lastMile.route",
        participantKey: "main.landing.multimodal.stages.lastMile.participant",
        statusKey: "main.landing.multimodal.stages.lastMile.status",
        checkpointKey: "main.landing.multimodal.stages.lastMile.checkpoint",
        documentsKey: "main.landing.multimodal.stages.lastMile.documents",
        scheduleKey: "main.landing.multimodal.stages.lastMile.schedule",
    },
];

export const multimodalDefaultStageId =
    multimodalRouteStages[0].id;

export const multimodalBenefitKeys = [
    "main.landing.multimodal.sales.benefits.contractors",
    "main.landing.multimodal.sales.benefits.bidding",
    "main.landing.multimodal.sales.benefits.documents",
    "main.landing.multimodal.sales.benefits.control",
];

export const multimodalControlKeys = [
    "main.landing.multimodal.controlSummary.items.events",
    "main.landing.multimodal.controlSummary.items.documents",
    "main.landing.multimodal.controlSummary.items.alerts",
];
